import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import apiConfig from '../config/apiConfig';

const CharacterCreation = () => {
  const { updateCharacter, user } = useContext(UserContext);
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [bio, setBio] = useState('');
  const [childCode, setChildCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // If a character already exists, redirect to main page.
  useEffect(() => {
    if (user && user.playerCharacter) {
      navigate('/');
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(apiConfig.character, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({ name, bio, childCode })
      });
      
      setLoading(false);
      
      if (!response.ok) {
        const errorData = await response.json();
        setError(errorData.message || 'Failed to create character.');
        return;
      }
      
      const createdCharacter = await response.json();
      // Update the user context with the new character.
      updateCharacter(createdCharacter);
      // Redirect to the main page.
      navigate('/');
    } catch (err) {
      setLoading(false);
      setError('Error: ' + err.message);
    }
  };

  return (
    <div className="page-content">
      <h2>Create Your Character</h2>
      {error && <div className="error-message">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div>
          <label>Name:</label>
          <input 
            type="text" 
            value={name} 
            onChange={(e) => setName(e.target.value)} 
            required 
          />
        </div>
        <div>
          <label>Bio:</label>
          <textarea 
            value={bio} 
            onChange={(e) => setBio(e.target.value)} 
            required
          ></textarea>
        </div>
        <div>
          <label>Child Code (Optional):</label>
          <input 
            type="text" 
            value={childCode} 
            onChange={(e) => setChildCode(e.target.value)}
          />
        </div>
        <button type="submit" disabled={loading}>
          {loading ? 'Creating...' : 'Create Character'}
        </button>
      </form>
    </div>
  );
};

export default CharacterCreation;
